import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Formclass } from '@app/models/formclass';
import { Member } from '@app/models/member';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class UserService {
  private apiUrl = 'https://localhost:8088/api/users';
  medlem: Observable<Member[]>;

  constructor(private http: HttpClient) { }

  getUsers(): Observable<Member[]> {
    return this.http.get<Member[]>('../assets/user.json');
  }

  getMemberById(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Member/GetMemberByIdAsync/1');
  }

  getMembersByBirthDateAsync(date): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Member/GetMembersByBirthDateAsync/' + date);
  }

  getMembers(): Observable<any> {
    return this.http.get('../assets/member.json')
      .pipe(map(result => result));

  }

  getUsersByValue(val): Observable<Formclass> {
    return this.http.get<Formclass>('../assets/user.json');
  }

  getTest(): string {
    return 'hello';
  }

  getRandomizedPassword(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'User/GetRandomizedPassword');
  }

  changeOwnPasswordAsync(newpasswordinfo: any): Observable<any> {
    const httpOptions: { headers; observe; } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      observe: 'response'
    };
    return this.http.post<any>(environment.apiUrl + 'User/ChangeOwnPasswordAsync', JSON.stringify(newpasswordinfo), httpOptions);
  }

  changeMemberPasswordAsync(newpasswordinfo: any): Observable<any> {
    const httpOptions: { headers; observe; } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      observe: 'response'
    };
    return this.http.post<any>(environment.apiUrl + 'User/ChangeMemberPasswordAsync', JSON.stringify(newpasswordinfo), httpOptions);
  }

  addMember(member: any): Observable<any> {
    const httpOptions: { headers; observe; } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      observe: 'response'
    };
    return this.http.post<any>(environment.apiUrl + 'Member/CreateNewMember', JSON.stringify(member), httpOptions);
  }

  getAgeDistribution(data: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Report/GetAgeDistributionReport', JSON.stringify(data), httpOptions);
  }

}
